import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../actions/index';
import {
  SearchBar,
  Title,
  TableFooter,
  Paper,
  Modal,
  ClientModal,
  EmptyView,
  Table,
  Button,
  Spinner
} from '../../components';
import {
  handleSearchChange,
  handleExportToCsv,
  handleSearchBlur,
  handleRowClick,
  handleCloseModal,
  initUsers
} from './Clients.services';
import { styles } from './Clients.styles';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/people.svg';
import { EMPTY_DESIGN_CLIENTS_TITLE } from '../../constants/dishopInfo';
import { CLIENT_TABLE_HEAD } from '../../constants/table';
import { UNIT } from '../../constants';
class Clients extends Component {
  state = {
    searchTerm: '',
    currentClients: [],
    isLoading: true,
    accesArray: [],
    client: {},
    allClients: {}
  };
  async componentDidMount() {
    await initUsers(this.props, this);
  }
  async componentWillReceiveProps(props) {
    const { shopId, isAllShops, page } = props;
    const { shopId: oldShopId, isAllShops: oldIsAllShops, page: oldPage } = this.props;
    if (
      !_.isEqual(shopId, oldShopId) ||
      (_.isEqual(shopId, oldShopId) && oldIsAllShops !== isAllShops) ||
      (!_.isEqual(page, oldPage) && isAllShops)
    ) {
      await initUsers(props, this);
    }
  }
  componentDidUpdate(prevProps) {
    const { shopId, isAllShops } = this.props;
    const { shopId: prevShopId, isAllShops: prevIsAllShops } = prevProps;
    if (!_.isEqual(shopId, prevShopId) || (_.isEqual(shopId, prevShopId) && prevIsAllShops !== isAllShops)) {
      this.setState({ searchTerm: '' });
    }
  }

  createTableRow = data => {
    const { classes } = this.props;
    return (
      <TableBody>
        {_.map(data, e => {
          const { email, nbTransaction, nbTransactionCanceled, totalMoneySpent, id, number } = e;
          return (
            <TableRow
              key={id}
              onClick={() => handleRowClick(e, this)}
              style={{ cursor: 'pointer' }}
            >
              <TableCell align="center" className={classes.valueC}>
                {email}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {number || '--'}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {nbTransaction || 0}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {nbTransactionCanceled || 0}{' '}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {' '}
                {totalMoneySpent} €{' '}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  render() {
    const { classes, showHelpModal } = this.props;
    const { client, modalOpen, currentClients, clients } = this.state;
    return (
      <div className="px-4 pb-4">
        <Title title="Clients" onClick={() => showHelpModal('clients')} />
        <div className="pb-3">
          <div className="row">
            {(_.size(clients) > 0) && (
              <>
                <div className="col mt-3 mt-sm-0 d-flex  align-self-center">
                  <SearchBar
                    value={this.state.searchTerm}
                    onChange={e => handleSearchChange(e, this)}
                    onClick={() => handleSearchBlur(this)}
                  />
                </div>
                <div className="col mt-3 mt-sm-0 d-flex flex-row-reverse align-self-center">
                  <Button
                    className="btn-xs-block"
                    onClick={() => {
                      handleExportToCsv(this);
                    }}
                    outlined
                    color="secondary"
                  >
                    Exporter la liste des clients
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
        {!(currentClients.size) > 0 ? (
          <EmptyView
            src={ImportedSVG}
            title={EMPTY_DESIGN_CLIENTS_TITLE}
            text={EMPTY_DESIGN_CLIENTS_TITLE}
            isLoading={this.state.isLoading}
          />
        ) : (
          <>
            <Paper scrollOption="auto">
              {this.state.isLoading ?
                <center><Spinner style={{ margin: UNIT * 5 }} /></center> :
                <Table
                  headCells={CLIENT_TABLE_HEAD}
                  classes={classes}
                  bodyRows={currentClients.data}
                  createTableRow={(currentClients) => this.createTableRow(currentClients)}
                  order="desc"
                  orderBy="totalMoneySpent"
                />
              }
            </Paper>

            <TableFooter lengthOption={currentClients.size} />
          </>
        )}

        <Modal
          color="secondary"
          title={`Détails du Client `}
          header
          fixed
          width="700px"
          onClick={() => handleCloseModal(this)}
          btnTxt="Retour"
          btnColor="secondary"
          handleClose={() => handleCloseModal(this)}
          isOpen={modalOpen}
        >
          <ClientModal client={client} />
        </Modal>
      </div>
    );
  }
}
function mapStateToProps({ user, page, firebaseRealTime }) {
  const { shopId, shopName, clients, isAllShops } = user;
  const { shops } = firebaseRealTime;

  return {
    page,
    clients,
    shopId,
    shopName,
    isAllShops,
    shops
  };
}

Clients.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(Clients));
